<template>
    <Modal :close_button="true" :size="'modal-md'" mid="confirm-delete-member-sessions">
        <template v-slot:header>{{$t('member_sessions.remove_all_title')}}</template>
        <template v-slot:body>
            <p v-if="member && member.username">
                {{$t('member_sessions.member_label')}}: <strong>{{member.username}}</strong>
            </p>
            <p class="mb-0">{{$t('member_sessions.remove_all_description')}}</p>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-danger bg-gradient px-4" :disabled="submitting" @click="submit()">
                <span v-if="submitting" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                {{$t('member_sessions.remove_all')}}
            </button>
            <button type="button" class="btn px-4" :disabled="submitting" @click="cancel()">
                {{$t('controls.cancel')}}
            </button>
        </template>
    </Modal>
</template>

<script>
import InventoryMemberStore from '@/common/store/inventory_member.js'

export default {
    props: {
        member: {
            type: Object,
            default: () => ({})
        }
    },
    data: function () {
        return {
            submitting: false
        }
    },
    methods: {
        cancel: function () {
            if (!this.submitting) {
                this.$bus.$emit('Modal/hide/confirm-delete-member-sessions')
            }
        },
        submit: async function () {
            if (this.submitting || !this.member || typeof this.member.id !== 'string') {
                return
            }

            this.submitting = true
            try {
                const response = await InventoryMemberStore.dispatch('DELETE_ALL_SESSIONS', {
                    member_id: this.member.id
                })

                if (response.status === 0) {
                    this.$bus.$emit('Notification/show', {
                        title: this.$t('notifications.operation_success'),
                        msg: this.$t('member_sessions.all_removed'),
                        level: 'success'
                    })
                    this.$bus.$emit('Modal/hide/confirm-delete-member-sessions')
                } else {
                    this.$bus.$emit('Notification/show', {
                        title: this.$t('notifications.something_went_wrong'),
                        msg: this.$t('notifications.please_retry_the_operation_or_refresh'),
                        level: 'danger'
                    })
                }
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>
